import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Stack,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../api";
import { useAppContext } from "../context/index";
import useLocalStorage from "../hooks/useLocalStorage";

export default function LoginPage() {
  const toast = useToast();
  const { store, loading } = useAppContext();
  const navigate = useNavigate();
  const outerBoxColor = useColorModeValue("gray.50", "gray.800");
  const innerBoxColor = useColorModeValue("white", "gray.700");

  useEffect(() => {
    if (store) navigate("/");
  }, [store]);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [storedValue, setValue] = useLocalStorage("token", null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (errors[name]) {
      const errorObj = { ...errors };
      delete errorObj[name];
      setErrors({ ...errorObj });
    }
    setFormData({ ...formData, [name]: value });
  };

  const validateLoginForm = (config) => {
    let objErrors = {};
    if (config.email === "" || !config.email) {
      objErrors.email = "Email is required";
    } else if (!config.password || config.password === "") {
      objErrors.password = "Password is required";
    } else {
      objErrors = {};
    }
    return objErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const objErrors = { ...errors, ...validateLoginForm(formData) };

    if (Object.keys(objErrors).length > 0) {
      console.log("objErrors", objErrors);
      setErrors(objErrors);
      toast({
        title: "Form Field Errors",
        description: "Please fill the fields correctly!",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    } else {
      API("/auth/login", "POST", formData)
        .then((data) => {
          if (data?.result?.token) {
            setValue(data?.result?.token);
            navigate("/");
          }
        })
        .catch((err) => {
          toast({
            title: "Authentication Failed!",
            description: err?.error ?? "Internal Server Error!",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
          console.log("error", err);
        });
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <Flex
        minH={"100vh"}
        align={"center"}
        justify={"center"}
        bg={outerBoxColor}
      >
        <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
          <Stack align={"center"}>
            <Heading fontSize={"4xl"}>Sign in to your account!</Heading>
          </Stack>
          <Box rounded={"lg"} bg={innerBoxColor} boxShadow={"lg"} p={8}>
            <Stack spacing={4}>
              <FormControl
                id="email"
                isRequired
                isInvalid={errors?.email ? true : false}
              >
                <FormLabel>Email</FormLabel>
                <Input
                  type="text"
                  name="email"
                  onChange={handleInputChange}
                  value={formData.email}
                />
                {errors?.email ? (
                  <FormErrorMessage>{errors?.email}</FormErrorMessage>
                ) : (
                  <></>
                )}
              </FormControl>
              <FormControl
                id="password"
                isRequired
                isInvalid={errors?.password ? true : false}
              >
                <FormLabel>Password</FormLabel>
                <Input
                  type="password"
                  name="password"
                  onChange={handleInputChange}
                  value={formData.password}
                />
                {errors?.password ? (
                  <FormErrorMessage>{errors?.password}</FormErrorMessage>
                ) : (
                  <></>
                )}
              </FormControl>
              <Stack spacing={10}>
                <Stack
                  direction={{ base: "column", sm: "row" }}
                  align={"start"}
                  justify={"space-between"}
                >
                  <Checkbox>Remember me</Checkbox>
                  <Text color={"blue.400"}>Forgot password?</Text>
                </Stack>
                <Button
                  bg={"black"}
                  color={"white"}
                  _hover={{
                    bg: "gray.600",
                    boxShadow: "lg",
                  }}
                  onClick={handleSubmit}
                >
                  Sign in
                </Button>
                <h3>
                  Don't have an accout?{" "}
                  <Link to="/register" style={{ color: "blue" }}>
                    <span> Sign Up</span>
                  </Link>
                </h3>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    </>
  );
}
